"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRulesServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class TaxRulesServiceLive {
    async getTaxRules(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/tax-rules`);
        return response.data;
    }
    async createTaxRuleSet(companyId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/tax-rules`, body);
        return response.data;
    }
    async updateTaxRuleDraft(companyId, body) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/tax-rules/draft`, body);
        return response.data;
    }
    async validateTaxRuleDraft(companyId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/tax-rules/draft/validate`, {});
        return response.data;
    }
    async publishTaxRuleDraft(companyId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/tax-rules/draft/publish`, body);
        return response.data;
    }
    async discardTaxRuleDraft(companyId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/tax-rules/draft`);
        return response.data;
    }
    async getTaxRuleSetHistory(companyId, params = {}) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/tax-rules/history`, params);
        return response.data;
    }
    async getDistributionTaxOutcomes(companyId, distributionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distributions/${distributionId}/tax-outcomes`);
        return response.data;
    }
}
exports.TaxRulesServiceLive = TaxRulesServiceLive;
//# sourceMappingURL=TaxRulesServiceLive.js.map